module.exports = __webpack_public_path__ + "static/media/logo.9bbe1b56.png";